<template>
	<section v-if="selectedHypermarket" class="container space-y-4 md:space-y-8">
		<h2 class="typo-h2 text-heading-secondary">
			{{ title }}
		</h2>
		<div v-if="pending" class="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-2 gap-4 sm:gap-6 md:gap-8 rem:auto-rows-[372px]">
			<div v-for="index in 8" :key="index" class="rounded-2.5xl shadow-md skeleton-gradient" />
		</div>
		<div v-else-if="actionOfferProducts?.products.length" class="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-2 gap-4 sm:gap-6 md:gap-8">
			<ProductTile
				v-for="(product, index) in actionOfferProducts?.products"
				:key="product.vanr ?? index"
				:product="product"
			/>
		</div>
		<div class="text-center">
			<AbsoluteInternalLink :to="branchSpecificPath({name: 'hypermarket-akcni-nabidka-category'})" class="btn btn-secondary btn-lg max-sm:w-full justify-center">
				Zobrazit celou akční nabídku
			</AbsoluteInternalLink>
		</div>
	</section>
</template>

<script setup lang="ts">
	import {storeToRefs} from 'pinia';
	import {useStoryblokHypermarketsStore} from '~/stores/storyblokHypermarkets';
	import {GsoaActionOffersService} from '~/openapi';

	interface Props {
		title: string;
		productList?: any[];
	}

	defineProps<Props>();

	const hypermarketsStore = useStoryblokHypermarketsStore();
	const branchSpecificPath = useBranchSpecificPath();

	const {selectedHypermarket, selectedHypermarketInstance} = storeToRefs(hypermarketsStore);

	const houseNumber = computed(() => selectedHypermarketInstance.value?.content.gsoaId);

	const {data: actionOfferProducts, pending, error} = await useLazyAsyncData(
		`actionOfferProductListing-${houseNumber.value ?? 'globus'}`,
		() => houseNumber.value
			? GsoaActionOffersService.getActionProductsCatalog({
				houseNumber: Number(houseNumber.value),
				pageSize: 8,
			})
			: Promise.resolve(null),
		{watch: [houseNumber]},
	);

	watch(error, (newError) => {
		if (newError) {
			useShowError(newError);
		}
	}, {immediate: true});
</script>
